import { DateStr } from '@ndvr/billing-api';

// Billing dates arrive as the services' LocalDate form (`2026-07-01Z`), always the 1st of a
// month — so the year and month segments are all this label needs.
export const billingDateLabel = (billingDate: DateStr) => {
    const [year, month] = billingDate.split('-');
    const monthName = new Date(Number(year), Number(month) - 1, 1).toLocaleString('en-US', { month: 'long' });
    return `1st ${monthName}, ${year}`;
};
